import { CALL_API } from "../api.middleware";
import {
	GET_NOTIFICATIONS,
	GET_NOTIFICATIONS_FAILED,
	GET_NOTIFICATIONS_SUCCESS,
	SAVE_DEVICE_TOKEN,
	SAVE_DEVICE_TOKEN_SUCCESS,
	SAVE_DEVICE_TOKEN_FAILED,
	UPDATE_NOTIFCATION_STATUS,
	UPDATE_NOTIFCATION_STATUS_SUCCESS,
	UPDATE_NOTIFCATION_STATUS_FAILED,
	CLEAR_ALL_NOTIFICATIONS,
	CLEAR_ALL_NOTIFICATIONS_SUCCESS,
	CLEAR_ALL_NOTIFICATIONS_FAILED,
	LOGOUT_SUCCESS,
} from "../Types";

// export const getNotifications = () => async (dispatch) => {
//   try {
//     await dispatch({
//       [CALL_API]: {
//         url: `/transaction/notifications`,
//         method: "GET",
//         types: [GET_NOTIFICATIONS, GET_NOTIFICATIONS_SUCCESS, GET_NOTIFICATIONS_FAILED],
//         showLoader: true,
//         additionalData: {
//           showError: false,
//         },
//       },
//     });
//   } catch (error) {
//     // alert(`${error}`);
//     console.error("Notif - 33", error);
//   }
// };

export const clearAllNotifications = () => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/notifications`,
				method: "DELETE",
				types: [
					CLEAR_ALL_NOTIFICATIONS,
					CLEAR_ALL_NOTIFICATIONS_SUCCESS,
					CLEAR_ALL_NOTIFICATIONS_FAILED,
				],
				showLoader: true,
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Notif - 53", error);
	}
};

export const saveDeviceToken = (body) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: "/transaction/booking/fcm-token",
				method: "POST",
				body,
				types: [SAVE_DEVICE_TOKEN, SAVE_DEVICE_TOKEN_SUCCESS, SAVE_DEVICE_TOKEN_FAILED],
				additionalData: {
					showError: false,
				},
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Notif - 72", error);
	}
};

export const updateNotificationStatus = (id, body) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/notifications/${id}`,
				method: "PATCH",
				body,
				types: [
					UPDATE_NOTIFCATION_STATUS,
					UPDATE_NOTIFCATION_STATUS_SUCCESS,
					UPDATE_NOTIFCATION_STATUS_FAILED,
				],
				showLoader: true,
				// showToast: true,
				// toastMessage: "Message updated successfully",
			},
		});
	} catch (error) {
		// alert(`${error}`);
		console.error("Notif - 95", error);
	}
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
